module.exports = __webpack_public_path__ + "media/images/riders/KATE_CURD-e3394a7ad09d62c429d0c4cba5e54b37.png";